import {kiwiLayout as tokensLayout} from '@findhotel/atlas-tokens'

export const layout = {
  maxPageWidth: 1168,
  radius: tokensLayout.radius,
  spacing: tokensLayout.spacing
}
